import React from 'react';
import _ from 'lodash';

import { selectListenersAllowedToSpeak, selectRaiseHandUsers } from 'client/redux/pubnub/selectors';
import { PubnubMsgsItem } from 'client/redux/pubnub/types';

import { useAppSelector } from './redux';

export const useWaitingList = () => {
  const raiseHandListenersList = useAppSelector(selectRaiseHandUsers);
  const allowedListenersToSpeakList = useAppSelector(selectListenersAllowedToSpeak);
  const waitingList: PubnubMsgsItem[] = React.useMemo(
    () => _.filter(raiseHandListenersList, (w) => w.uuid !== allowedListenersToSpeakList[0]?.id),
    [raiseHandListenersList, allowedListenersToSpeakList],
  );

  return waitingList;
};
